import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";

export const CampusHostelDetails = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <div>
        {/* Start Page Banner */}
        <div className="page-banner-area bg-1">
          <div className="container">
            <div className="page-banner-content">
              <h1>Campus Hostel</h1>
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li className="navspace">
                  <Link to="/campus">Campus</Link>
                </li>
                <li className="navspace">Hostel</li>
              </ul>
            </div>
          </div>
        </div>
        {/* End Page Banner */}

        {/* Start Academic Details Area */}
        <div className="academics-details-area pt-100 pb-70">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="academics-details">
                  <div className="details">
                    <h2>Embrace Comfort and Community at the Hostel</h2>
                    <p>
                      At <strong>McGAN’S Ooty School of Architecture</strong>, we provide
                      comfortable, secure, and modern hostel accommodations to
                      ensure that our students have a safe and conducive
                      environment for learning and living.
                    </p>

                    <div className="details-images">
                      <div className="row">
                        <div className="col-lg-4 col-md-4">
                          <img
                            src="assets/images/campus-detail/hostel1.webp" width={6000} height={4000} 
                            alt="Hostel Room"
                            height={357}
                            width={416}
                          />
                        </div>
                        <div className="col-lg-4 col-md-4">
                          <img
                            src="assets/images/campus-detail/hostel.jpg"
                            alt="Hostel Exterior"
                            height={357}
                            width={416}
                          />
                        </div>
                        <div className="col-lg-4 col-md-4">
                          <img
                            src="assets/images/campus-detail/hostel3.webp"
                            alt="Hostel Facilities"
                            height={357}
                            width={416}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="prepare-exam">
                    <h3>Room Options</h3>
                    <div className="row">
                      <div className="col-lg-6 col-md-6">
                        <div className="exam-card">
                          <h4>Single Rooms</h4>
                          <p>
                            Ideal for students seeking privacy and personal
                            space. Each room is well-ventilated and fully
                            furnished for comfort.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="exam-card">
                          <h4>Shared Rooms (2 Persons)</h4>
                          <p>
                            Comfortable and well-furnished for students who
                            prefer sharing. Perfect balance between privacy and
                            community.
                          </p>
                        </div>
                      </div>
                    </div>

                    <h3 className="mt-4">Modern Amenities</h3>
                    <div className="row">
                      <div className="col-lg-6 col-md-6">
                        <div className="exam-card">
                          <h4>Attached Bathrooms</h4>
                          <p>
                            Every room comes with a private, clean, and
                            functional bathroom ensuring comfort and hygiene.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="exam-card">
                          <h4>Water Heater & Room Heater</h4>
                          <p>
                            To ensure a comfortable stay throughout the year,
                            rooms are equipped with both water and room heaters.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="exam-card">
                          <h4>High-Speed WiFi Campus</h4>
                          <p>
                            Stay connected for studies, research, and personal
                            communication with uninterrupted high-speed WiFi.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="exam-card">
                          <h4>24x7 Power Supply</h4>
                          <p>
                            Uninterrupted electricity ensures all academic and
                            personal needs are met without disruption.
                          </p>
                        </div>
                      </div>
                    </div>

                    <h3 className="mt-4">Dining & Hygiene</h3>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="exam-card">
                          <h4>Hygienic Dining Facilities</h4>
                          <p>
                            Nutritious meals are served in a clean and
                            well-maintained dining area, ensuring students'
                            health and well-being.
                          </p>
                        </div>
                      </div>
                    </div>

                    <h3 className="mt-4">Safety & Security</h3>
                    <div className="row">
                      <div className="col-lg-6 col-md-6">
                        <div className="exam-card">
                          <h4>Separate Hostels for Girls & Boys</h4>
                          <p>
                            Each hostel is supervised by dedicated wardens of
                            the respective gender, ensuring safety and privacy
                            for all residents.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="exam-card">
                          <h4>Round-the-Clock Security</h4>
                          <p>
                            24/7 security personnel and surveillance systems
                            ensure a safe and peaceful environment for every
                            student.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Academic Details Area */}
      </div>
    </>
  );
};